var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2461 16.4179C18.399 16.4179 20.955 13.8619 20.955 10.709C20.955 7.55599 18.399 5 15.2461 5C12.0931 5 9.53711 7.55599 9.53711 10.709C9.53711 13.8619 12.0931 16.4179 15.2461 16.4179Z",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2977 27.2681L5 27.2681",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0056 27.2697V26.0024C26.0056 20.7987 21.6315 16.5803 16.2358 16.5803H13.7933C10.8439 16.5803 8.1998 17.8407 6.40845 19.8335",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7195 22.7185L18.774 26.9591C18.8202 26.9979 18.8572 27.0457 18.8826 27.0992C18.9079 27.1527 18.921 27.2107 18.921 27.2694C18.921 27.3281 18.9079 27.3862 18.8826 27.4397C18.8572 27.4932 18.8202 27.5409 18.774 27.5797L13.7195 31.8212",
    fill: "#00842F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogin);
export default __webpack_public_path__ + "static/media/user-login.a63cde0a.svg";
export { ForwardRef as ReactComponent };